<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('superviseur.aValider.title') }}</h2>
    </div>

    <el-card class="box-card">
      <el-tabs v-model="activeType" @tab-click="handleTabChange">
        <el-tab-pane :label="$t('superviseur.types.ci')" name="ci" />
        <el-tab-pane :label="$t('superviseur.types.formation')" name="formation" />
        <el-tab-pane :label="$t('superviseur.types.audit')" name="audit" />
        <el-tab-pane :label="$t('superviseur.types.parcelle')" name="parcelle" />
      </el-tabs>

      <ci-supervision-list v-if="activeType === 'ci'" embedded />
      <parcelles-modifications-list v-else-if="activeType === 'parcelle'" />
      <activites-list v-else :type="activeType" />
    </el-card>
  </div>
</template>

<script>
import CiSupervisionList from '@/views/controle-interne/supervision/List';
import ActivitesList from './components/ActivitesList';
import ParcellesModificationsList from './components/ParcellesModificationsList';

export default {
  name: 'SuperviseurAValider',
  components: { CiSupervisionList, ActivitesList, ParcellesModificationsList },
  data() {
    return {
      activeType: 'ci',
    };
  },
  created() {
    const type = this.$route.query.type;
    if (type === 'ci' || type === 'formation' || type === 'audit' || type === 'parcelle') {
      this.activeType = type;
    }
  },
  methods: {
    handleTabChange() {
      const query = { ...this.$route.query, type: this.activeType };
      this.$router.replace({ query });
    },
  },
};
</script>
